<div class="flex justify-center items-center w-full h-full font-poppins">
    <div class="flex justify-center items-center w-full h-full relative">
      <svg xmlns="http://www.w3.org/2000/svg" width="321" height="317" viewBox="0 0 321 317" fill="none" class="opacity-80 z-10">
        <path d="M320 1H1V316H5.20844H187.855L320 171.816V1Z" fill="url(#paint0_linear_1_13)" fill-opacity="1" stroke="white" />
        <defs>
          <linearGradient id="paint0_linear_1_13" x1="160.5" y1="64.7975" x2="160.5" y2="316" gradientUnits="userSpaceOnUse">
            <stop stop-color="#1D2555" />
            <stop offset="1" stop-color="#05050C" />
          </linearGradient>
        </defs>
      </svg>
      <div class="absolute z-20 w-full flex justify-center items-center">
        <form class="flex flex-col justify-center items-center" (ngSubmit)="resetPassword()">
          <div class="flex flex-col justify-start text-center">
            <div class="flex items-center justify-between border-b-2 border-white p-2 mt-2 w-[250px]">
              <input type="password" [(ngModel)]="newPassword" name="newPassword" placeholder="Enter password" class="bg-transparent text-white outline-none" #newPasswordInput>
              <button type="button" (click)="togglePasswordVisibility('newPassword', newPasswordInput)">
                <i *ngIf="!showPassword.newPassword" class="fas fa-eye-slash"></i>
                <i *ngIf="showPassword.newPassword" class="fas fa-eye"></i>
              </button>
            </div>
            <div class="flex items-center justify-between border-b-2 border-white p-2 mt-2 w-[250px]">
              <input type="password" [(ngModel)]="confirmPassword" name="confirmPassword" placeholder="Confirm password" class="bg-transparent text-white outline-none" #confirmPasswordInput>
              <button type="button" (click)="togglePasswordVisibility('confirmPassword', confirmPasswordInput)">
                <i *ngIf="!showPassword.confirmPassword" class="fas fa-eye-slash"></i>
                <i *ngIf="showPassword.confirmPassword" class="fas fa-eye"></i>
              </button>
            </div>
          </div>
          <button type="submit" class="relative w-[250px] h-[50px] mt-2 bg-[#31A1F6] text-white transform -translate-x-[60px] translate-y-[40px]">
            Login
          </button>
        </form>
      </div>
    </div>
  </div>
  